enum Preference {
    Temporary = 1,
    Permanent = 2,
    HealthEmergency = 3,
    TaxEfficient = 4,
}

enum Rider {
    None = 1,
    Critical = 2,
    Chronic = 3,
    Both = 4,
}

enum ProductType {
    Temporary = 1,
    Basic = 2,
    Best = 3,
    Retirement = 4,
    VUL = 5,
}

const ProductTypeForHubspot = {
    '1': 'Temporary',
    '2': 'Basic Permanent',
    '3': 'Best Value',
    '5': 'VUL',
};

export const ProductTypeForLeadTable = {
    '1': 'temporary',
    '2': 'basic',
    '3': 'best',
    '4': 'retirement',
    '5': 'vul',
};

enum LeadAttributes {
    CalculatedQuote = 'calculated_quote',
}
